export default "__VITE_ASSET__DsBqc1GA__"